module.exports = __webpack_public_path__ + "assets/img/a72a648b9d7cd4cd8b1e4e0b39d295c3.png";